<template>
  <div class="hot-team-product">
     <div class="plate-title">
        <span><img src="../../assets/svg/hot-team-product.svg"/></span>
        <p>选择困难？瞅一下，别人家的团建怎么玩～</p>
    </div>
    <!-- 产品 -->
     <div class="card-content">
          <div class="card-content-list" v-for="(itemOut,index) in indexTb" :key="index">
            <div class="card-category-img" @click="goTeamBuildListByTypeId(itemOut.tbTypeId)">
              <img :src="message.picPreUrl+itemOut.tbTypePic" />
            </div>
          <div  v-for="(item,index) in itemOut.tbList" :key="index">
            <div class="card-content-item1 card-content-item"
              v-on:mouseover="showPicTxt(itemOut.tbTypeId,item.id)"
              v-on:mouseleave="hidePicTxt()"
              @click="gotoTbDetail(item.id)">
              <div class="background-pic2" v-if="item.image" v-bind:style="{backgroundImage:'url(' +'\''+ item.image[0] +'\''+ ')'}"></div>
              <div class="title" v-if="item.title">{{item.title}}</div>
              <div class="tags" v-if="item.tbProfit"><span class="tbProfit">{{item.tbProfit}}</span></div>
              <div class="days"><span v-if="item.day" class="first-span">{{item.day}}天{{item.night}}晚 </span>|<span>{{item.numberMin}}-{{item.numberMax}}人</span></div>
              <div class="price" ><span v-if="item.price">¥ {{item.price}}</span></div>
              <div class="product-reason"  v-if="isShowPicTxt == itemOut.tbTypeId+'.'+item.id">
                <p class="product-title">推荐理由</p>
                 <div></div>               
                <p class="product-subtitles">{{item.introduce}}</p>
                <span class="more">
                  更多
                </span>
              </div>
            </div>
          </div>
        </div>
            <div class="show-all" @click="goTeamBuildListByTypeId()"><span>全部产品</span></div> 
     </div>           
    <!-- 视频区 -->
     <div class="swiper-wrapper" ref="videoModule" v-if="videoList.length> 0">
        <swiper
        v-if="videoList.length > 0"
        :options="swiperOptionTop"
        class="gallery-top"
        ref="swiperTop"
      >
        <swiper-slide
          class="slide-1"
          v-for="(item,index) in videoList"
          :key="index"
        > 
          <div class="swiper-content"> 
            <div class="cover-view"></div>
            <video 
            id="videoBox" controls="controls" ref="videoPlay" :poster="item.path"
            :src="item.video"></video>
          </div>
        </swiper-slide>
        <!-- <div class="swiper-button-next swiper-button-gray" slot="button-next"></div>
        <div class="swiper-button-prev swiper-button-gray" slot="button-prev"></div> -->
        <!-- <div class="swiper-pagination" slot="pagination"></div> -->
      </swiper>
     </div>

  </div>
</template>

<script>
import axios from "axios";
import {handlePicPlusPre,handleVideo} from "../../util/util"

export default {
  name:"hotTeamProduct",
  components: {
    
  },
  props:["message"],
  computed:{
    getPreUrl(){
      return this.$store.state.picPreUrl
    },
    getLocationSiteCityId(){
      return this.$store.state.locationSiteCity;
      if(locationSiteCity){
        return locationSiteCity
      }else{
        return 5
      }
    }
  },
  data() {
    return {
      id: null,
      // message: null,
      indexTb:[],
      isShowPicTxt:-1,
      // 视频区参数
      swiperOptionTop: {
        autoplay: false,
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 1,
        centeredSlides: true,
        paginationClickable: true,
        resistanceRatio: 0 ,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        on: {
          init() {
            this.setTranslate(0);
          },
          transitionStart() {
            // 开始translate之前触发
            // 如果是第一张
            if (this.activeIndex == 0) {
              this.setTranslate(0); // 因为左边会空出一张图的距离，所以设置位移为0
            }
          },
        },
        swiperLoading:false
      },
      // 视频列表
      videoList:[],
      plays:false
    };
  },
  watch: {},
  computed: {
   getScrolltop() {
      let _this = this;
      window.addEventListener("scroll", () => {
        _this.top =
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          window.pageYOffset;
      });
      return _this.top > 300;
    },
    initSwiper(){
      const _this = this;
       new Swiper('.cooperative-swiper-wrapper',{
        swiperOptionTop:this.swiperOptionTop
       })
    },
    
  },
  methods: {
    handlePicPlusPre,
    handleVideo,
    // 通过类型id去团建页面
    goTeamBuildListByTypeId(tbTypeId){

      // console.log("type")
      // console.log(this.$store.state.locationSiteCity)
      // return;
      this.$router.push({
        path: "/teamBuilding",
        query: { typeId: tbTypeId }
      });
    },
    // 去团建详情页
    gotoTbDetail(id) {
       window.open("/#/teamBuildingDetail?id="+id)
    },
    showPicTxt(typeId,tbId) {
      this.isShowPicTxt = typeId+'.'+tbId
    },
    hidePicTxt() {
      this.isShowPicTxt = -1;
    },
    videoAction (){
    this.plays=!this.plays;
    if(this.plays){
      this.$refs["videoPlay"].play();
    }else{
       this.$refs["videoPlay"].pause();
    }
        //或者
	//var video=document.getElementById("videoBox");
	//video.play();
	//暂停
	//video.pause();
  },
  initContent(){
    this.getTeamBuildList();
    this.getVideoList();
  },
    getTeamBuildList(){
      const params = {
        departCityId:this.$store.state.locationSiteCity?this.$store.state.locationSiteCity:5,
        // pageNum:1,
        // pageSize:3,
        limitVal:3
      }
      axios
        .get(`/api/tb/indexList`, {
          params,
        })
        .then((res) => {
          if (res.status == 200) {
            this.indexTb = res.data.indexTb;
            this.indexTb.forEach(tbListItem =>{
            tbListItem.tbList.forEach(element => {
              if(element.profitNames){
              let profitList = element.profitNames.split(" ");
              console.log("profit")
              console.log(profitList)
              let tbProfit = "";
              profitList.forEach(profit => {
                if(tbProfit!=""){
                  tbProfit = tbProfit + " · " + profit;
                }else{
                  tbProfit = profit;
                }
              });
              console.log(tbProfit)
              element.tbProfit = tbProfit;
            if(element.image) {
              element.image = handlePicPlusPre(element.image);
            }
            this.loading = false;
            }
        });
        })
      }
      
    });
  },
  // 获取视频
    getVideoList(){
      const params = {
        positionId:13,
        cityId:this.$store.state.locationSiteCity?this.$store.state.locationSiteCity:5
      }
      axios
        .get(`/api/adm/list`, {
          params
        })
        .then((res) => {
          // console.log(res)
          if(res.data &&res.data.code == 200){
              this.videoList = res.data.adList;
              
            this.videoList.forEach(videoItem=>{
              if(videoItem.path){
                videoItem.path =  this.handlePicPlusPre(videoItem.path);
                videoItem.path = videoItem.path[0]
              }
              if(videoItem.video){
                videoItem.video =  this.handleVideo(videoItem.video);
              }
            })  
          }
        })
    },  
  },
  created() {
  },
  mounted() {
    this.initContent();
  }
};
</script>
<style scoped>
.hot-team-product{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;
  height: 100%;
}
.hot-team-product .plate-title{
      min-height: 160px;
}
.hot-team-product .plate-title span{
    display: inline-block;
    text-align: center;
    width: 100%;
    font-size: 38px;
    color: #201f1f;
    /* padding-top: 50px; */
}
.hot-team-product .plate-title p{
    display: inline-block;
    text-align: center;
    width: 100%;
    font-size: 18px;
    color: #666;
    /* padding-top: 20px; */
    padding-bottom: 40px;
}

.hot-team-product .card-content {
  width: 1060px;
  /* position:absolute; */
  /* height: 100%; */
  /* display: flex;
  flex-direction: row;
  justify-content: center; */
}
.card-content div .background-pic2 {
  /* width: 100%;
  height: 50%;
  background-size: 100% 100%;
  background-repeat: no-repeat;   */
  /* border-radius: 6px; */
    height: 160px;
    width: 100%;
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;
}
.card-content .product-reason {
  transition: all 0.3s ease-in-out;
  background: #359ff8;
  opacity: 0.9;
  position: absolute;
  left: 0;
  top: 0px;
  width: 100%;
  height: 100%;
  padding: 50px 28px;
  box-sizing: border-box;
  text-align: center;
  border-radius: 6px;
}
.card-content .product-reason span{
 
}
.card-content .product-title {
    font-size: 20px;
    color: #222;
    font-weight: 700;
}

.card-content .product-subtitles {
    font-size: 14px;
    color: #222;
    padding-top: 0px;
}
.card-content .card-content-item{
    height: 380px;
    flex-shrink: 0;
    background: #fff;
    border: 1px solid #f5f5f5;
    height: 338px;
    width: 260px;
    display: block;
    border-radius: 8px;
    transition: all .3s ease-in-out;
    overflow: hidden;
    position: relative;  
}
.card-content .product-reason div{
    transition: all .3s ease-in-out;
    font-size: 14px;
    color: #000;
    border-bottom: 1px solid #000;
    margin: 15px 15px;
    height: 1px;
    text-align: center;
}
.card-content .product-reason span{
    display: block;
    text-align: right;
    font-size: 12px;
    color: #222;
    position: absolute;
    right: 35px;
    bottom: 60px;
}
.card-content-item .title{
    font-weight: 700;
    font-size: 16px;
    color: #222;
    overflow: hidden;
    letter-spacing: 0;
    padding: 13px 18px;
}
.card-content-item .tags{
      padding: 0px 20px;
}
.card-content-item .days{
      padding: 0 18px;
}
.card-content-item .days .first-span{
      padding: 0 5px 0 0px;
}
.card-content-item .price{
    position: absolute;
    bottom: 14px;
    left: 18px;
}
.card-content-item .tags span{
    height: 20px;
    line-height: 20px;
    display: inline-block;
    font-size: 13px;
    color: #5a5a5a;
    text-align: left;
}
.card-content-item .days span{
    height: 18px;
    line-height: 18px;
    color: #666;
    padding:0px 5px;
    font-size: 13px;
}
.card-content-item .price span{
    font-weight: 700;
    font-size: 18px;
    color: #f9541c;  
}
.card-content-item .price span:after {
    content: " 起/人";
    color: #222;
    font-size: 14px;
}
.card-category-img img{
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%; 
}
.card-category-img {
  margin-bottom: 34px;
  transition: all .3s ease-in-out;
  width: 235px;
  height: 338px;
  /* padding: 0px 10px; */
  box-sizing: border-box;
}
.el-row{
  height: 390px;
}
/* .card-content :nth-child(2).el-col{
  margin: 0px 55px;
} */
p{
  text-align: left;
}
div{
  text-align: left;
}
.card-content .show-all{
    text-align: center;
    width: 100%;
    padding: 40px 0;
}
.card-content .show-all span{
    background: #f2f2f2;
    border-radius: 6px;
    font-size: 16px;
    color: #222;
    padding: 12px 118px;
    cursor: pointer;
}
</style>
// 视频
<style scoped>
.swiper-wrapper {
  position: relative;
  height: 400px;
  width: 100%;
  margin-top: 20px;
  background: #000;
}
.swiper-wrapper >>> .swiper-pagination-bullet {
  background: #e4e4e4 !important;
}
.swiper-wrapper >>> .swiper-pagination-bullet-active {
  background: #000000 !important;
}
.swiper-wrapper >>> .swiper-slide-prev {
  position: relative;
  left: 100px;
  /* left: -20px; */
}
.swiper-wrapper >>> .swiper-slide-next {
  position: relative;
   left: -100px;
  /* left: -10px; */
}
.swiper-wrapper >>>.swiper-slide{
    width: 979px;
    height: 416px;
    transition: all .3s ease-in-out;
    transform: scaleY(.94);
    overflow: hidden;
}

.swiper-wrapper >>> .swiper-slide-active {
    transform: scale(1) !important;
    z-index: 1000;
    box-shadow: 0 2px 8px 0 rgb(0 0 0 / 30%);
    border-radius: 6px;
}
.swiper-wrapper >>> .swiper-slide {
    transform: scale(0.9);
    border-radius: 6px;
}
/* .swiper-wrapper >>> .swiper-slide-active {
  transform: scale(1.1);
} */
.swiper-pagination >>> span {
  width: 12px !important;
  height: 12px !important;
}
.swiper-container {
  background-color: #fff;
}
.swiper-slide {
  background-size: cover;
  background-position: center;
  width: 100% !important;
}
/* .gallery-top {
  height: 100% !important;
  width: 100%;
}
.gallery-top .slide-1{
  background-position: center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  position: relative;
}
.gallery-top .slide-1  a {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.gallery-thumbs {
  position: absolute;
  right: 50px;
  top: 150px;
  width: 100px;
  height: 190px;
  padding: 0 5px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 5px;
} */
.swiper-wrapper .swiper-content{
    /* width: 979px;
    height: 416px; */
    height: 800px;
    width: 800px;
    border-radius: 6px;
    position: relative;
    /* padding: 0 100px; */
    /* background-size: cover;
    background-repeat: no-repeat;
    transition: all .3s ease-in-out; */
}
.swiper-wrapper .swiper-slide {
    width: 979px!important;
    height: 416px;
}
.swiper-content .cover-view{
  position:absolute;
  opacity: 0.5;
  z-index: 1000;
  background:#fff;
  width: 979px;
  height: 416px;
}

.swiper-wrapper >>> .swiper-slide-active .swiper-content .cover-view{
  position:absolute;
  opacity: 0;
  z-index: -1;
}
.swiper-wrapper .swiper-content video{
    width: 979px;
    height: 416px;
    border-radius: 6px;
        object-fit: cover;
    /* background-size: cover;
    background-repeat: no-repeat;
    transition: all .3s ease-in-out; */
}
.swiper-wrapper .swiper-button-gray{
    z-index: 1000;
    transition: all .2s ease-in-out;
    opacity: 0;
    color: #fff7;
    position: absolute;
    width: 60px;
    height: 60px;
    background: rgba(0,0,0,.2);
    border-radius: 30px;
}
.swiper-wrapper:hover  .swiper-button-gray{
    z-index: 1000;
    transition: all .2s ease-in-out;
    opacity: 1;
    color: #fff7;
    position: absolute;
    width: 60px;
    height: 60px;
    background: rgba(0,0,0,.2);
    border-radius: 30px;
}
/*禁用video的controls（要慎重！不要轻易隐藏掉，会导致点击视频不能播放）*/
video::-webkit-media-controls {
  /* display:none !important; */
  opacity: 0;
}

.card-content-list{
  flex-direction: row;
    flex-wrap: wrap;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
}
.tags .tbProfit{
overflow: hidden;
white-space: nowrap;
text-overflow: ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/components/home/hotTeamProduct.vue